import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with credentials
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Districts API
export const districtsApi = {
  getAll: async () => {
    const response = await api.get('/districts');
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/districts/${id}`);
    return response.data;
  },
};

// Properties API
export const propertiesApi = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.type && filters.type !== 'all') params.append('type', filters.type);
    if (filters.district && filters.district !== 'all') params.append('district', filters.district);
    if (filters.priceType && filters.priceType !== 'all') params.append('price_type', filters.priceType);
    if (filters.minPrice) params.append('min_price', filters.minPrice);
    if (filters.maxPrice) params.append('max_price', filters.maxPrice);
    if (filters.bedrooms && filters.bedrooms !== 'any') params.append('bedrooms', filters.bedrooms);
    if (filters.search) params.append('search', filters.search);
    
    const response = await api.get(`/properties?${params.toString()}`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await api.get(`/properties/${id}`);
    return response.data;
  },
  
  create: async (propertyData) => {
    const response = await api.post('/properties', propertyData);
    return response.data;
  },
  
  update: async (id, propertyData) => {
    const response = await api.put(`/properties/${id}`, propertyData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await api.delete(`/properties/${id}`);
    return response.data;
  },
};

// Auth API
export const authApi = {
  processSession: async (sessionId) => {
    const response = await api.post('/auth/session', { session_id: sessionId });
    return response.data;
  },
  
  getMe: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};

export default api;
